import type { RouteObject } from "react-router";
import { DownloadReportsPage } from "./DownlaodReportsPage";

export const route: RouteObject = { path: "download", element: <DownloadReportsPage /> };
